// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-prgress-bar {
    position: absolute;
    z-index: 1;
}

:host {
    display: block;
}

a {
    color: red;
    cursor: pointer;
    text-decoration: underline;
}

@keyframes router-load-indicator-animation {
    from {
        opacity: 0.0;
    }

    to {
        opacity: 1.0;
    }
}

.router-load-indicator {
    animation-delay: 100ms;
    animation-duration: 200ms;
    animation-fill-mode: both;
    animation-name: router-load-indicator-animation;
    background-color: #ffdc73;
    border-radius: 5px 5px 5px 5px;
    box-shadow: 0px 2px 2px fade(#000000, 20%);
    color: #000000;
    font-family: monospace;
    font-size: 16px;
    left: 50%;
    padding: 7px 15px 7px 15px;
    position: fixed;
    text-transform: lowercase;
    top: 10px;
    transform: translateX(-50%);
    z-index: 2;
}


.fixposition {
    position: fixed;
    left: 0;
    right: 0;
    margin: auto;
    bottom: 10px;
    z-index: 9999;
    border-radius: 4px;
    max-width: 33vw;
    min-width: 344px;
}

.init-image-loader {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,yBAAyB;IACzB,+CAA+C;IAC/C,yBAAyB;IACzB,8BAA8B;IAC9B,0CAA0C;IAC1C,cAAc;IACd,sBAAsB;IACtB,eAAe;IACf,SAAS;IACT,0BAA0B;IAC1B,eAAe;IACf,yBAAyB;IACzB,SAAS;IACT,2BAA2B;IAC3B,UAAU;AACd;;;AAGA;IACI,eAAe;IACf,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB;AACJ","sourcesContent":[".page-prgress-bar {\r\n    position: absolute;\r\n    z-index: 1;\r\n}\r\n\r\n:host {\r\n    display: block;\r\n}\r\n\r\na {\r\n    color: red;\r\n    cursor: pointer;\r\n    text-decoration: underline;\r\n}\r\n\r\n@keyframes router-load-indicator-animation {\r\n    from {\r\n        opacity: 0.0;\r\n    }\r\n\r\n    to {\r\n        opacity: 1.0;\r\n    }\r\n}\r\n\r\n.router-load-indicator {\r\n    animation-delay: 100ms;\r\n    animation-duration: 200ms;\r\n    animation-fill-mode: both;\r\n    animation-name: router-load-indicator-animation;\r\n    background-color: #ffdc73;\r\n    border-radius: 5px 5px 5px 5px;\r\n    box-shadow: 0px 2px 2px fade(#000000, 20%);\r\n    color: #000000;\r\n    font-family: monospace;\r\n    font-size: 16px;\r\n    left: 50%;\r\n    padding: 7px 15px 7px 15px;\r\n    position: fixed;\r\n    text-transform: lowercase;\r\n    top: 10px;\r\n    transform: translateX(-50%);\r\n    z-index: 2;\r\n}\r\n\r\n\r\n.fixposition {\r\n    position: fixed;\r\n    left: 0;\r\n    right: 0;\r\n    margin: auto;\r\n    bottom: 10px;\r\n    z-index: 9999;\r\n    border-radius: 4px;\r\n    max-width: 33vw;\r\n    min-width: 344px;\r\n}\r\n\r\n.init-image-loader {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100vh\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
